import {Component, computed, inject, input} from '@angular/core';
import {FormControl} from '@angular/forms';
import {TranslatePipe} from '@ngx-translate/core';
import {Dropdown} from '../../../../../../../../components/dropdown/dropdown';
import {AccountingAccountStoreService} from '../../services/accounting-account-store.service';
import {AccountingAccountSummary} from '../../../../../../../../../api';

@Component({
  selector: 'elcia-accounting-account-dropdown',
  imports: [Dropdown, TranslatePipe],
  templateUrl: './accounting-account-dropdown.html',
})
export class AccountingAccountDropdown {
  private readonly store = inject(AccountingAccountStoreService);
  accountingAccounts = computed<AccountingAccountSummary[]>(() => this.store.accountingCodes());
  control = input.required<FormControl>();
}
